import { Create, useGetIdentity } from 'react-admin';
import { transformMediaUrlInput } from '../../lib/media/makeUrl'
import { fromGenericToUTC } from '../../lib/i18n/utils';
import { AgendaForm } from './AgendaForm';
import { usePermissionGuard } from '../../lib/permissions/usePermissionGuard';

export const AgendaCreate = (props: any) => {
  const { guard } = usePermissionGuard();
  const transform = data => ({
    ...data,
    isLocalNews: guard.forceLocal() ? guard.forceLocal() : data.isLocalNews,
    publishedAt: data.publishedAt ? fromGenericToUTC(data.publishedAt) : null,
    newsIds: data.newsIds ?? [],
    topicIds: data.topicIds ?? [],
    sectorIds: data.sectorIds ?? [],
    mediaUrl: transformMediaUrlInput(data.mediaUrl)
  });

  const { identity, isLoading } = useGetIdentity();
  if (isLoading && !identity) return null;

  return (
    <Create {...props} transform={transform}>
      <AgendaForm />
    </Create>
  );
};
